import React, { useCallback } from "react"
import { ContentActionDispatcher } from "../../../../../../actiondispacher/content-action-dispacher"
import { IEditorContent } from "../../../../../../types"
import { Button } from "../../../../../../../../components/parts/buttons/button"
import styled from "styled-components"
import Color from "../../../../../../../../style/enum/color"

interface IProps {
  content: IEditorContent
  actions: ContentActionDispatcher
}

export const Remove = (props: IProps) => {
  const showMode = useCallback(() => {
    props.actions.clickRestoreRemoveContent(props.content.uuid)
    // eslint-disable-next-line
  }, [props.content.uuid])

  return (
    <StyledButton onClick={showMode}>削除済み (クリックで復元)</StyledButton>
  )
}

const StyledButton = styled(Button).attrs({
  borderColor: Color.TRANSPARENT,
})`
  margin: 20px 0;
  padding: 20px 0;
  font-size: 1rem;
  display: block;
`
